import { createSlice } from '@reduxjs/toolkit';
import { loadingSlice } from 'sg-ui-components';

export const defaultlongPlayGametate = {
    boards: {},
    boardDetails: {},
    winsAndPrizes: {},
};

// REDUCERS
// basic actions that affect this object only
const getBoardsReducer = (state, action) => {
    return {
        ...state,
        boards: {
            ...state.boards,
            [action?.payload?.game_id]: Array.isArray(action?.payload?.boards) ? action?.payload?.boards : [],
        },
    };
};

const getBoardReducer = (state, action) => {
    return {
        ...state,
        boardDetails: {
            ...state.boardDetails,
            [action?.payload?.board_id]: action?.payload?.result ?? {},
        },
    };
};

const getWinsAndPrizesReducer = (state, action) => {
    return {
        ...state,
        winsAndPrizes: {
            ...state.winsAndPrizes,
            [action?.payload?.game_id]: Array.isArray(action?.payload?.result) ? action?.payload?.result : [],
        },
    };
};

const resetReducer = () => {
    return {
        ...defaultlongPlayGametate,
    };
};

export const longPlayGameSlice = createSlice({
    name: 'longPlayGame',
    initialState: defaultlongPlayGametate,
    reducers: {
        getBoards: getBoardsReducer,
        getBoard: getBoardReducer,
        getWinsAndPrizes: getWinsAndPrizesReducer,
        reset: resetReducer,
    },
});

// ACTUAL ACTIONS
// a place to make the actions more complex if necessary
const getBoards = async (dispatch, game_id, apiClient) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'getBoards' }));
    const result = await apiClient().getGameEngineGameBoards({ game_id: game_id });
    dispatch(longPlayGameSlice.actions.getBoards({ game_id, ...result }));
    dispatch(loadingSlice.actions.unsetLoading({ action: 'getBoards' }));
};

const getBoard = async (dispatch, payload, apiClient) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'getBoard' }));
    const result = await apiClient().getGameEngineGameBoard({ game_id: payload?.game_id, board_id: payload?.board_id });
    dispatch(longPlayGameSlice.actions.getBoard({ ...payload, result }));
    dispatch(loadingSlice.actions.unsetLoading({ action: 'getBoard' }));
};

const getWinsAndPrizes = async (dispatch, game_id, apiClient) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'getWinsAndPrizes' }));
    const result = await apiClient().getGameEngineGameWinTypesWithPrizes({ game_id: game_id });
    dispatch(longPlayGameSlice.actions.getWinsAndPrizes({ game_id, result }));
    dispatch(loadingSlice.actions.unsetLoading({ action: 'getWinsAndPrizes' }));
};

//actions that get exported to the views
export const longPlayGameActions = (dispatch, apiClient) => {
    return {
        getBoards: (payload) => getBoards(dispatch, payload, apiClient),
        getBoard: (payload) => getBoard(dispatch, payload, apiClient),
        getWinsAndPrizes: (payload) => getWinsAndPrizes(dispatch, payload, apiClient),

        reset: (payload) => dispatch(longPlayGameSlice.actions.reset(payload)),
    };
};
